export default {
  list: { lazy: () => import('./GlobalSupplierPaymentMethods'), component: 'GlobalSupplierPaymentMethodList' },
  create: { lazy: () => import('./GlobalSupplierPaymentMethods'), component: 'GlobalSupplierPaymentMethodCreate' },
  edit: { lazy: () => import('./GlobalSupplierPaymentMethods'), component: 'GlobalSupplierPaymentMethodEdit' },
}
